import React from "react";
import { Divider, Grid, Typography } from "@material-ui/core";
import EducationalMaterials from "../EducationalMaterials";
import { makeStyles } from "@material-ui/core/styles";
import { useFirebaseRemoteConfig } from "../../states/firebase";
const useStyles = makeStyles(theme => ({
  title: {
    paddingRight: theme.spacing(2),
    fontSize: theme.typography.pxToRem(20),
    fontWeight: theme.typography.fontWeightMedium
  },
  divider: {
    marginRight: theme.spacing(2)
  }
}));

const TitleWithEducationalMaterials = props => {
  const { title, showDivider, stickToRight, ...educationalMaterialsProps } =
    props;

  // General
  const classes = useStyles();

  // Customs
  const firebaseRemoteConfig = useFirebaseRemoteConfig();

  return (
    <Grid container alignItems="center">
      <Grid item>
        <Typography className={classes.title}>{title}</Typography>
      </Grid>
      {firebaseRemoteConfig.ready && (
        <>
          {showDivider && (
            <Divider
              orientation="vertical"
              flexItem
              className={classes.divider}
            />
          )}
          <Grid
            item
            style={{ position: stickToRight ? "absolute" : "", right: 24 }}
          >
            <EducationalMaterials {...educationalMaterialsProps} />
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default TitleWithEducationalMaterials;
